import { deactivateExpenseAccount } from '../../../../../actions/Utilities/VendorConfiguration';
import { toast } from "components/toastNotification";
import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { expenseAccountReFetching } from "../atoms/atoms";

export default function useDeactivateExpenseAccount() {
  const [isReFetching, setIsReFetching] = useRecoilState(
    expenseAccountReFetching
  );
  const { mutate } = useMutation(
    (ids: number[]) => deactivateExpenseAccount(ids),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire(
            "Disabling Expense Account failed",
            res.Message,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Expense Account Disabled Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Expense Account Disabled Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Disabling Expense Account failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "Expense account not found":
              toast.fire(
                "Disabling Expense Account failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Disabling Expense Account failed", res, "error");
          }
        }
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error) => {
        toast.fire(
          "Disabling Expense Account failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );

  return mutate;
}